






























import { Component, Vue, Prop } from 'vue-property-decorator';
import IdentityData from '@/ts/IdentityData';

@Component
export default class AccountSwitcherItem extends Vue {
    @Prop({ default: null }) public identity: IdentityData;
    @Prop({ default: false }) public selected: boolean;
    @Prop({ default: false }) public withAnchor: boolean;
    @Prop({ default: 'down' }) public anchorDir: string;

    constructor() {
        super();
    }
}
